export default "__VITE_ASSET__B$r5IM72__"